
import React,{useState} from 'react'
import { useParams } from 'react-router-dom';
import { Card } from 'primereact/card'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import axios from 'axios';
// import jwt from 'jsonwebtoken'

const PasswordReset = (props) => {
    const {id} = useParams()
    // const email = jwt.verify(id, "MY_SECRET_TOKEN")
    // console.log(email)

    const [value, setValue] = useState('');

    const onSubmitForm = async (event) => {
        event.preventDefault()
        const data = {
            email: '',  //How to get email?
            token: id,
            password: value
        }
        const response = await axios.post('http://localhost:5001/api/auth/reset-password', data)
        //Validations maybe
        //Redirection??
    }

    return (
        <div className="h-screen center-flex">
            <Card className='w-5 h-20rem' title="Set New Password">
                <form onSubmit={onSubmitForm}>
                    <span className="center-flex align-items-start">
                        <label htmlFor="password" className='password-reset-label'>Password</label>
                        <InputText id="password" value={value} onChange={(e) => setValue(e.target.value)} autoComplete="off" className='w-7' />
                    </span>
                    <div className=" center-flex p-0 m-5">
                        <Button label="Submit" severity="success" className="w-3" />
                    </div>
                </form>
            </Card>
        </div>
    )
}

export default PasswordReset